import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const Footer = () => (
  <footer className="border-t border-white/[0.06] px-6 lg:px-16 py-14">
    <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
      <div>
        <div className="font-display font-extrabold text-2xl tracking-tight">
          BEFORA<span className="text-[#10B981]">.</span>
        </div>
        <p className="text-sm text-[#6B7280] mt-2">Web Sitesi & Mobil Uygulama Geliştirme</p>
      </div>

      <button
        onClick={() => window.__lenis?.scrollTo("#basvuru", { offset: -72 })}
        data-testid="footer-apply-button"
        className="group flex items-center gap-2 text-sm text-[#9CA3AF] hover:text-[#10B981] transition-colors duration-300"
      >
        Projen için başvur
        <ArrowUpRight size={15} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
      </button>

      <div className="flex items-center gap-6 text-sm text-[#6B7280]">
        <a
          href="mailto:beforanet@gmail.com"
          data-testid="footer-email-link"
          className="hover:text-[#10B981] transition-colors duration-300"
        >
          beforanet@gmail.com
        </a>
        <Link to="/admin" data-testid="footer-admin-link" className="hover:text-white transition-colors duration-300">
          Yönetici Girişi
        </Link>
        <span className="font-code text-xs">© 2026 BEFORA</span>
      </div>
    </div>
  </footer>
);

export default Footer;
